import OptionsOperator from "./config/options/operators.json";
import defaultRoutes from "./json/defaultRoutes.json";

const _config = (props) => {

    if (props.OptionsOperator) return(OptionsOperator);
    if (props.Enviroment) return(process.env.REACT_APP_ENV_TYPE);
    if (props.DefaultRoutes) return (defaultRoutes);
    return null;
}

export default _config;